import { gql } from '@apollo/client';

export const ANSWER_MUTATION = gql`
  mutation AnswerReleasedSurveyMutation($input: AnswerReleasedSurveyInput!) {
    answerReleasedSurvey(input: $input) {
      releasedSurvey {
        id
      }
    }
  }
`;

export const REFUSE_MUTATION = gql`
  mutation RefuseReleasedSurveyMutation($id: UUID!) {
    updateReleasedSurveyById(input: { id: $id, patch: { status: REFUSED } }) {
      clientMutationId
    }
  }
`;
